import { render, staticRenderFns } from "./Payresult.vue?vue&type=template&id=0340f9a5&"
import script from "./Payresult.vue?vue&type=script&lang=js&"
export * from "./Payresult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports